import { render, staticRenderFns } from "./AddonPopover.vue?vue&type=template&id=3e483c0d&scoped=true"
import script from "./AddonPopover.vue?vue&type=script&lang=js"
export * from "./AddonPopover.vue?vue&type=script&lang=js"
import style0 from "./AddonPopover.vue?vue&type=style&index=0&id=3e483c0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e483c0d",
  null
  
)

export default component.exports